import { Box } from '@mui/material';
import GoogleMap from '../../../components/maps/googlemap/GoogleMap';
import GoogleTripDirections from '../../../components/maps/googledirection/GoogleTripDirections';
import './PramaLink.scss';

interface Location {
  lat: number;
  lng: number;
}
function PramaLink() {
  const locations: Location[] = [
    {
      lat: 13.0347,
      lng: 80.1645
    },
    {
      lat: 12.2253,
      lng: 79.0747
    }
  ];

  return (
    <Box className='pramalink-container'>
      <GoogleMap>
        <GoogleTripDirections
          origin={locations[0]}
          destination={locations[locations.length - 1]}
        />
      </GoogleMap>
    </Box>
  );
}

export default PramaLink;
